import React, { Component } from 'react'
import OverlayLoadingIndicator from 'components/common/OverlayLoadingIndicator'

import styles from './loading-component.scss'

class LoadingComponent extends Component {
  render() {
    return (
      <div className={styles['loading-container']}>
        <OverlayLoadingIndicator loading dark />
      </div>
    )
  }
}

export default LoadingComponent



// WEBPACK FOOTER //
// ./src/components/common/LoadingComponent/LoadingComponent.jsx